export const initialState = {
  coords: { x: null, y: null },
  chapterTargets: [],
  momentTargets: [],
  targets: [],
  action: null,
  overlappingId: null,
  overlappingChapterId: null,
  overlappingValueId: null,
  overlappingIndex: null,
  layoutUpdatedAt: null,
  draggingItem: null,
  metaKey: false,
};

export const dragging = (state = initialState, action) => {
  const { type, ...data } = action;
  switch (type) {
    case "dragging/start": {
      const dragging = {
        ...state,
        coords: {
          ...state.coords,
          ...action.coords,
        },
      };
      return {
        ...dragging,
      };
    }
    case "dragging/end": {
      return initialState;
    }
    case "dragging/update": {
      const dragging = {
        ...state,
        coords: {
          ...state.coords,
          ...action.coords,
        },
      };
      return {
        ...dragging,
      };
    }
    case "dragging/set_dragging_item": {
      const dragging = {
        ...state,
        draggingItem: action.draggingItem,
      };
      return {
        ...dragging,
      };
    }
    case "dragging/set_layout_updated_at": {
      const dragging = {
        ...state,
        layoutUpdatedAt: action.layoutUpdatedAt,
      };
      return {
        ...dragging,
      };
    }
    case "dragging/set_overlap_id": {
      const dragging = {
        ...state,
        overlappingId: action.overlappingId,
      };
      return {
        ...dragging,
      };
    }
    case "dragging/set_overlap_chapter_id": {
      const dragging = {
        ...state,
        overlappingChapterId: action.overlappingChapterId,
      };
      return {
        ...dragging,
      };
    }
    case "dragging/set_overlap_value_id": {
      const dragging = {
        ...state,
        overlappingValueId: action.overlappingValueId,
      };
      return {
        ...dragging,
      };
    }
    case "dragging/update_target": {
      let targets = [];
      let target = state.targets.find((t) => t.id == action.target.id);
      if (!!target) {
        targets = state.targets.map((t) => {
          if (t.id == target.id) {
            return {
              ...target,
              ...action.target,
            };
          } else return t;
        });
      } else {
        targets = [...state.targets, action.target];
      }
      const dragging = {
        ...state,
        targets,
      };
      return {
        ...dragging,
      };
    }
    case "dragging/add_chapter_target": {
      const dragging = {
        ...state,
        chapterTargets: [...state.chapterTargets, action.target],
      };
      return {
        ...dragging,
      };
    }
    case "dragging/update_chapter_target": {
      const target = state.chapterTargets.find((t) => t.id == action.target.id);
      const chapterTargets = state.chapterTargets.map((t) => {
        if (t.id == target.id) {
          return {
            ...target,
            ...action.target,
          };
        } else return t;
      });
      const dragging = {
        ...state,
        chapterTargets,
      };
      return {
        ...dragging,
      };
    }
    case "dragging/add_moment_target": {
      const dragging = {
        ...state,
        momentTargets: [...state.momentTargets, action.target],
      };
      return {
        ...dragging,
      };
    }
    case "dragging/set_value": {
      let { type, ...params } = action;
      const dragging = {
        ...state,
        ...params,
      };
      return {
        ...dragging,
      };
    }
    case "dragging/set_action": {
      const dragging = {
        ...state,
        action: action.action,
      };
      return {
        ...dragging,
      };
    }
    case "dragging/set_overlap_index": {
      const dragging = {
        ...state,
        overlappingIndex: action.overlappingIndex,
      };
      return {
        ...dragging,
      };
    }
    default:
      return state;
  }
};
